import React from "react";
import { motion } from "framer-motion";

type PerkItemProps = {
  icon: React.ReactElement;
  title: string;
  text: string;
  href?: string; // optional link target
};

const workItemVariants = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 240, damping: 22 },
  },
};

export const PerkItem: React.FC<PerkItemProps> = ({
  icon,
  title,
  text,
  href,
}) => {
  const Wrapper: any = href ? "a" : "div";

  return (
    <motion.div
      variants={workItemVariants}
      whileHover={{ y: -6, scale: 1.02 }}
      transition={{ type: "spring", stiffness: 260, damping: 18 }}
      className="text-center mb-10"
    >
      <Wrapper
        {...(href ? { href } : {})}
        className={`block ${href ? "cursor-pointer hover:text-white" : ""}`}
      >
        <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full border border-white">
          {React.cloneElement(icon, {
            className: "h-7 w-7",
            "aria-hidden": true,
          })}
        </div>

        <h3 className="font-semibold mb-2">{title}</h3>
        <p className="mb-2">{text}</p>

        {href && (
          <span className="inline-block text-sm underline text-white/70 hover:text-white transition-colors">
            Read more →
          </span>
        )}
      </Wrapper>
    </motion.div>
  );
};
